export default __webpack_public_path__ + "static/media/InstantWithdrawals-Desktop.98b51a97.png";